import { CmsObjectWithDefault } from '@components/Cms/types';

export type AuthedPhoneAssociationFormCmsKey =
    | 'pleaseEnterValidMobileNumber'
    | 'sendOtpButton'
    | 'phonenumberPlaceholder'
    | 'PhoneAssociationTitle1'
    | 'PhoneAssociationTitle2'
    | 'pleaseEnterValidMobileNumber'
    | 'pleaseTryAgain'
    | 'invalidOtpCode'
    | 'technicalDifficulty'
    | 'youAreNotAllowed'
    | 'successfulAssociation'
    | 'alreadyVerified'
    | 'phoneAlreadyExist';

export const AuthedPhoneAssociationFormCmsWithDefault: CmsObjectWithDefault<AuthedPhoneAssociationFormCmsKey> = {
    pleaseEnterValidMobileNumber: {
        cmsId: 85560,
        defaultTranslation: 'Please enter a valid mobile number.',
    },
    sendOtpButton: {
        cmsId: 97925,
        defaultTranslation: 'Send OTP',
    },
    phonenumberPlaceholder: {
        cmsId: 82026,
        defaultTranslation: 'Mobile number',
    },
    PhoneAssociationTitle1: {
        cmsId: 82597,
        defaultTranslation: "Enter your mobile number and we'll send you a verification code to {0}",
    },
    PhoneAssociationTitle2: {
        cmsId: 126746,
        defaultTranslation: 'associate the number with your account',
    },
    pleaseTryAgain: {
        cmsId: 269092,
        defaultTranslation: 'Sorry, we have encountered a technical issue. Please try again.',
    },
    invalidOtpCode: {
        cmsId: 97933,
        defaultTranslation: 'The OTP code is incorrect. Please re-enter or request a new OTP.',
    },
    technicalDifficulty: {
        cmsId: 101793,
        defaultTranslation: 'We are currently experiencing technical difficulties.',
    },
    youAreNotAllowed: {
        cmsId: 252851,
        defaultTranslation: 'You are not allowed to access the page',
    },
    successfulAssociation: {
        cmsId: 252852,
        defaultTranslation: 'You have successfully verified your account',
    },
    alreadyVerified: {
        cmsId: 258967,
        defaultTranslation: 'You have already verified your phone number.',
    },
    phoneAlreadyExist: {
        cmsId: 83203,
        defaultTranslation: 'Please use another mobile number.',
    },
};
